<script lang="ts">
    import UserIcon from '@amp/web-app-components/assets/icons/user-icon.svg';
    /**
     * App translate function
     * @type {(key) => string}
     */
    export let translateFn: (key: string) => string;
</script>

<!-- added "commerce-button" as a class until automation can change their selectors -->
<button
    tabindex="0"
    data-testid="sign-in-button"
    class="commerce-button signin"
    on:click
>
    <UserIcon class="auth-icon" />
    <span class="button-text">
        {translateFn('AMP.Shared.AX.SignIn')}
    </span>
</button>

<style lang="scss">
    //
    // Sign In Button
    //
    // *cssprop {String} --text-color
    //   Color of "Sign In" text and icon
    //

    .signin {
        align-items: center;
        border-radius: 6px;
        display: inline-flex;
        height: 28px;
        justify-content: center;
        min-width: 64px;
        padding: 0 12px;
        white-space: nowrap;
        color: var(--text-color, var(--keyColor));
        font: var(--body-emphasized);

        :global(.auth-icon) {
            display: none;
        }

        @media (--sidebar-visible) {
            background-color: var(--keyColorBG);
            color: var(--text-color, white);

            :global(.auth-icon) {
                display: block;
                fill: var(--text-color, white);
                margin-inline-end: 6px;
            }
        }
    }
</style>
